import { NL_AOVQL_KNOWLEDGE_FORM_ID } from '@orus.eu/standalone-form-product-nl-aovql'

import { ensureNlAovqlKnowledgeFormAccess } from './components/nl-aovql-knowledge/nl-aovql-knowledge-queries.ts'
import type { StandaloneFormAccess } from './standalone-form-access.types.ts'

import type { RouterContext } from '#/shared/routing/router-context.ts'

/** Read by the route loader, which loads with the app: a flow imported here would load with it. */
type StandaloneFormRegistration = {
  /** Also loads the context query the flow reads. */
  ensureFormAccess: (routerContext: RouterContext, subscriptionId: string) => Promise<StandaloneFormAccess>
}

const standaloneForms = {
  [NL_AOVQL_KNOWLEDGE_FORM_ID]: { ensureFormAccess: ensureNlAovqlKnowledgeFormAccess },
} satisfies Record<string, StandaloneFormRegistration>

/** Also keys the flows of `standalone-form-page.tsx`, so both list the same forms. */
export type StandaloneFormId = keyof typeof standaloneForms

export function isStandaloneFormId(formId: string): formId is StandaloneFormId {
  return Object.hasOwn(standaloneForms, formId)
}

/** Undefined for an id no standalone form registered, which the route turns into a not-found. */
export function findStandaloneForm(formId: string): StandaloneFormRegistration | undefined {
  return isStandaloneFormId(formId) ? standaloneForms[formId] : undefined
}
